import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
  routes: [
    {
      path: '*',
      redirect: '/index'
    },
    {
      path: '',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      meta: {showTabBar: true},
      component: () => import('@/components/index/index/index')
    },
    {
      path: '/noviceRace',
      name: 'noviceRace',
      meta: {showTabBar: false},
      component: () => import('@/components/index/novice-race/index')
    },
    {
      path: '/enterprice',
      name: 'enterprice',
      meta: {showTabBar: false},
      component: () => import('@/components/index/enterprice-competition/index')
    },
    {
      path: '/holdContest',
      name: 'holdContest',
      meta: {showTabBar: false},
      component: () => import('@/components/index/enterprice-competition/hold-contest')
    },
    {
      path: '/ranking',
      name: 'ranking',
      meta: {showTabBar: false},
      component: () => import('@/components/index/ranking/index')
    },
    {
      path: '/week-top',
      name: 'week-top',
      meta: {showTabBar: false},
      component: () => import('@/components/competition/week-top/week-top')
    },
    {
      path: '/monthTop3',
      name: 'month-improve-top3',
      meta: {showTabBar: false},
      component: () => import('@/components/index/ranking/month-improve-top3')
    },
    {
      path: '/cmptCircle',
      name: 'cmpt-circle',
      meta: {showTabBar: false},
      component: () => import('@/components/index/cmpt-circle/index')
    },
    // Dc积分
    {
      path: '/famous-hall-illustration',
      name: 'famous-hall-illustration',
      meta: {showTabBar: false},
      component: () => import('@/components/index/famous-hall-illustration/famous-hall-illustration')
    },
    // 年度积分 annual-illustration
    {
      path: '/annual-illustration',
      name: 'annual-illustration',
      meta: {showTabBar: false},
      component: () => import('@/components/index/annual-illustration/annual-illustration')
    },
    // DC竞赛年度英雄榜奖励机制
    {
      path: '/incentive-mechanism',
      name: 'incentive-mechanism',
      meta: {showTabBar: false},
      component: () => import('@/components/index/incentive-mechanism/incentive-mechanism')
    },
    {
      path: '/search',
      name: 'search',
      meta: {showTabBar: false},
      component: () => import('@/components/index/search/index')
    },
    // {
    //     path: '/login',
    //     name: 'login',
    //     meta: {showTabBar: false},
    //     component: () => import('@/components/reg-login/login')
    // },
    // {
    //     path: '/phoneRegister',
    //     name: 'phoneRegister',
    //     meta: {showTabBar: false},
    //     component: () => import('@/components/reg-login/phone-register')
    // },
    // {
    //     path: '/emailRegister',
    //     name: 'emailRegister',
    //     meta: {showTabBar: false},
    //     component: () => import('@/components/reg-login/email-register')
    // },
    // {
    //     path: '/phoneRetrieval',
    //     name: 'phoneRetrieval',
    //     meta: {showTabBar: false},
    //     component: () => import('@/components/reg-login/phone-retrieval')
    // },
    // {
    //     path: '/emailRetrieval',
    //     name: 'emailRetrieval',
    //     meta: {showTabBar: false},
    //     component: () => import('@/components/reg-login/email-retrieval')
    // },
    {
      path: '/serviceRegulations',
      name: 'serviceRegulations',
      meta: {showTabBar: false},
      component: () => import('@/components/reg-login/service-regulations')
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      meta: {showTabBar: false},
      component: () => import('@/components/reg-login/privacy-policy')
    },
    {
      path: '/competition',
      name: 'competition',
      meta: {showTabBar: true},
      component: () => import('@/components/competition/competition-list/competition-list')
    },
    {
      path: '/article-details',
      name: 'article-details',
      meta: {showTabBar: false},
      component: () => import('@/components/competition/article-details/article-details')
    },

    {
      path: '/competition-detail',
      name: 'competition-detail',
      meta: {showTabBar: false},
      component: () => import('@/components/competition/competition-detail/competition-detail'),
      //  嵌套子路由
      children: [
        {
          path: '/cmptDetail.html',
          name: 'CmptDetail',
          component: () => import('@/components/competition/competition-detail-tab/competition-message/competition-message')
        },
        {
          path: '/competition-taskdata',
          name: 'competition-taskdata',
          component: () => import('@/components/competition/competition-detail-tab/competition-taskdata/competition-taskdata')
        },
        {
          path: '/competition-article',
          name: 'competition-circle',
          component: () => import('@/components/competition/competition-detail-tab/competition-circle/competition-circle')
        },
        {
          path: '/competition-submission',
          name: 'competition-submission',
          component: () => import('@/components/competition/competition-detail-tab/competition-submission/competition-submission')
        },
        {
          path: '/competition-message',
          component: () => import('@/components/competition/competition-detail/competition-detail')
        },
        {
          path: '/competition-ranking',
          name: 'competition-ranking',
          component: () => import('@/components/competition/competition-detail-tab/competition-ranking/competition-ranking')
        },
        {
          path: '/competition-competitors',
          name: 'competition-competitors',
          component: () => import('@/components/competition/competition-detail-tab/competition-competitors/competition-competitors')
        },
        {
          path: '/competition-teams',
          name: 'competition-teams',
          component: () => import('@/components/competition/competition-detail-tab/competition-teams/competition-teams')
        },
        {
          path: '/competition-myteam',
          name: 'competition-myteam',
          component: () => import('@/components/competition/competition-detail-tab/competition-myteam/competition-myteam')
        },
        // 赛事新闻
        {
          path: 'news-list.html',
          name: 'news-list',
          component: () => import('@/components/competition/competition-detail-tab/news/index.vue')
        }
      ]
    },
    // 赛事新闻详情
    {
      path: '/news-detail.html',
      name: 'news-detail',
      component: () => import('@/components/competition/competition-detail-tab/news/detail.vue')
    },
    {
      path: '/invite-friend',
      name: 'invite-friend',
      meta: {showTabBar: false},
      component: () => import('@/components/competition/invite-friend/invite-friend')
    },
    {
      path: '/team-homepage',
      name: 'team-homepage',
      meta: {showTabBar: false},
      component: () => import('@/components/competition/team-homepage/team-homepage')
    },
    {
      path: '/competitor-page',
      name: 'competitor-page',
      meta: {showTabBar: false},
      component: () => import('@/components/competition/competitor-page/competitor-page')
    },
    {
      path: '/team-page',
      name: 'team-page',
      meta: {showTabBar: false},
      component: () => import('@/components/competition/team-page/team-page')
    },
    // DataCastle竞赛作弊管理规则
    {
      path: '/competition-managerule',
      name: 'competition-managerule',
      meta: {showTabBar: false},
      component: () => import('@/components/competition/competition-managerule/competition-managerule')
    },
    // 个人主页路由
    {
      path: '/myIndex/:data/:id',
      name: 'myIndex',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/my-index/index')
    },
    // 个人邮箱部分
    {
      path: '/mailBox/:tab',
      name: 'mailBox',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/mailbox/index')
    },
    {
      path: '/mailBox/privateLetter/:tab/:content',
      name: 'privateLetter',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/mailbox/private-letter')
    },
    {
      path: '/mailBox/systemDetail/:tab/:content',
      name: 'systemDetail',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/mailbox/system-detail')
    },
    // 我的个人资料部分
    {
      path: '/myInfo',
      name: 'myInfo',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/my-info/index')
    },
    // 我的个人资料部分(新网)
    {
      path: '/xinwang-myInfo/:url',
      name: 'xinwangMyInfo',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/my-info/xinwang-index')
    },
    // 实名认证---首页
    {
      path: '/certification',
      name: 'certification',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/certification/index')
    },
    // 实名认证---认证信息填写页面
    {
      path: '/certification/certificationInfo',
      name: 'certificationInfo',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/certification/cer-info')
    },
    // 实名认证---申诉页面
    {
      path: '/certification/certificationApply',
      name: 'certificationApply',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/certification/cer-apply')
    },
    // 实名认证完善个人资料
    {
      path: '/complete-info',
      name: 'complete-info',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/complete-info/complete-info')

    },
    // 选择认证方式---实名信用认证的输入信息页面
    {
      path: '/choose-cer',
      name: 'choose-cer',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/certification/choose-cer')
    },
    // 选择认证方式---芝麻信用认证方式扫码页面
    {
      path: '/choose-cer/cer-credit',
      name: 'cer-credit',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/certification/cer-credit')
    },
    // 我的--账号设置首页
    {
      path: '/accountSetting',
      name: 'accountSetting',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/account-setting/index')
    },
    // 我的手机号设置
    {
      path: '/phoneSetting',
      name: 'phoneSetting',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/account-setting/phone-setting')
    },
    // 我的邮箱设置
    {
      path: '/emailSetting',
      name: 'emailSetting',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/account-setting/email-setting')
    },
    // 我的----密码设置
    {
      path: '/passwordSetting',
      name: 'passwordSetting',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/account-setting/password-setting')
    },
    // 我的----意见反馈
    {
      path: '/feedBack',
      name: 'feedBack',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/feed-back/index')
    },
    // 我的tab页面路由
    {
      path: '/mine',
      name: 'mine',
      meta: {showTabBar: true},
      component: () => import('@/components/mine/mine/mine')
    },
    // 个人主页,竞赛与成就组件
    {
      path: '/home-page',
      name: 'home-page',
      meta: {showTabBar: false},
      component: () => import('@/components/mine/home-page/home-page')
    },
    // 新网银行
    {
      path: '/xinwang2',
      name: 'xinwang',
      meta: {showTabBar: false},
      component: () => import('@/components/activities/xinwang20190905/index.vue')
    },
    // 报名表单
    {
      path: '/joinForm.html',
      name: 'JoinForm',
      meta: {showTabBar: false},
      component: () => import('@/components/competition/join-form/index.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js